"use client"

import {
  CookieConsent,
  defaultConsent,
  getConsent,
  clearNonEssentialCookies,
} from "@/lib/cookies"
import { useCookies } from "@/lib/context/cookie-context"
import { Button, Label, Switch, Heading, Text } from "@medusajs/ui"
import { useState, useEffect } from "react"

function CookiePreferences() {
  const [consentSettings, setConsentSettings] =
    useState<CookieConsent>(defaultConsent)
  const { updateConsent } = useCookies()

  useEffect(() => {
    setConsentSettings(getConsent())
  }, [])

  const handleSavePreferences = () => {
    updateConsent(consentSettings)
    alert("Vaše nastavitve piškotkov so bile shranjene.")
  }

  const handleRejectAll = () => {
    updateConsent(defaultConsent)
    setConsentSettings(defaultConsent)
    clearNonEssentialCookies()
    alert("Zavrnili ste vse neobvezne piškotke.")
  }

  const handleToggleConsent = (
    category: keyof Omit<CookieConsent, "consentDate" | "necessary">
  ) => {
    setConsentSettings((prev) => ({
      ...prev,
      [category]: !prev[category],
    }))
  }

  return (
    <div className="max-w-2xl mx-auto">
      <div className="space-y-4 py-4">
        <div className="flex items-center justify-between">
          <div>
            <Label htmlFor="necessary-cookies" className="font-medium">
              Obvezni piškotki
            </Label>
            <p className="text-sm text-navy">
              Ti piškotki so nujni za delovanje spletne strani.
            </p>
          </div>
          <Switch id="necessary-cookies" checked={true} disabled={true} />
        </div>

        <div className="flex items-center justify-between">
          <div>
            <Label htmlFor="preferences-cookies" className="font-medium">
              Piškotki za nastavitve
            </Label>
            <p className="text-sm text-navy">
              Ti piškotki si zapomnijo vaše nastavitve.
            </p>
          </div>
          <Switch
            id="preferences-cookies"
            checked={consentSettings.preferences}
            onCheckedChange={() => handleToggleConsent("preferences")}
          />
        </div>

        <div className="flex items-center justify-between">
          <div>
            <Label htmlFor="analytics-cookies" className="font-medium">
              Analitični piškotki
            </Label>
            <p className="text-sm text-navy">
              Ti piškotki nam pomagajo izboljšati našo spletno stran.
            </p>
          </div>
          <Switch
            id="analytics-cookies"
            checked={consentSettings.analytics}
            onCheckedChange={() => handleToggleConsent("analytics")}
          />
        </div>

        <div className="flex items-center justify-between">
          <div>
            <Label htmlFor="marketing-cookies" className="font-medium">
              Marketinški piškotki
            </Label>
            <p className="text-sm text-navy">
              Ti piškotki se uporabljajo za marketinške namene.
            </p>
          </div>
          <Switch
            id="marketing-cookies"
            checked={consentSettings.marketing}
            onCheckedChange={() => handleToggleConsent("marketing")}
          />
        </div>
      </div>
      <div className="flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2 mt-6">
        <Button variant="secondary" onClick={handleRejectAll}>
          Zavrni vse
        </Button>
        <Button variant="primary" onClick={handleSavePreferences}>
          Shrani nastavitve
        </Button>
      </div>
    </div>
  )
}

export default function CookiesPage() {
  return (
    <div className="container mx-auto py-12 px-4">
      <Heading level="h1" className="mb-4">
        Politika piškotkov
      </Heading>
      <Text className="mb-8">
        Uporabljamo piškotke za izboljšanje vaše izkušnje na naši spletni strani. 
        Spodaj lahko upravljate z nastavitvami piškotkov. Za več informacij 
        preberite našo celotno politiko piškotkov.
      </Text>
      <CookiePreferences />
    </div>
  )
} 